import React, { Fragment } from "react"
import classnames from "classnames"

import styles from "./styles.css"
import Typograph from "components/Typograph/index"

function SelectNumberSkeleton() {
  return (
    <Fragment>
      <div className={styles.containerSelectInput}>
        <Typograph
          htmlTag="h2"
          weight="bold"
          size="small"
          color="charcoal_grey"
        >
          Selecione o número
        </Typograph>
        <div
          className={classnames(styles.formSkeletonInputFull, styles.skeleton)}
        ></div>
        <div
          className={classnames(
            styles.formSkeletonInputFull,
            styles.formSkeletonInputBigger,
            styles.skeleton
          )}
        ></div>
        <div className="u-flex u-flexJustifyEnd">
          <div
            className={classnames(
              styles.buttonLeft,
              styles.button,
              styles.skeleton
            )}
          ></div>
          <div className={classnames(styles.button, styles.skeleton)}></div>
        </div>
      </div>
    </Fragment>
  )
}

export default SelectNumberSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/DetailingPosPreControleSkeleton/SelectNumberSkeleton.js